export default __webpack_public_path__ + "static/media/desawar_jodi_digit.ac9eb6ae.png";